import { PropsWithChildren, JSX } from 'react';

interface TooltipProps extends PropsWithChildren {
  readonly tooltip: JSX.Element;
}

export function Tooltip({ tooltip, children }: TooltipProps) {
  return (
    <div className="tooltip">
      {tooltip}
      <span className="tooltiptext">{children}</span>
    </div>
  );
}
